export const mapContextToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
  }));

  return result;
};

export const ttsContextColumns = [
  { key: "contextNamespace", label: "Namespace", align: "center" },
  { key: "contextName", label: "Name", align: "center" },
  { key: "type", label: "type", align: "center" },
];
